import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import ScheduleForm from './ScheduleForm';
import TimeZones from '../../Common/Appointment/Timezones';
import CustomCards from '../../Common/Appointment/CustomAppointmentCard';
import { getSessionStorageItem } from '../../../../sessionStorage';
import './ScheduleAppointment.scss';

export default function SelectAppointment(props) {
    const navigate = useNavigate();
    const sessionStorageHealthData = getSessionStorageItem(props.sessionKey);

    useEffect(() => {
        window.scroll(0, 0);
    }, []);
    
    const goBack = () => {
        navigate(-1); 
    };

    return (
        <Container className='custom-appointment-info select pt-4'>
            <Row>
                <Col md={6} className="review-container d-flex align-items-center w-100">
                    <CustomCards title={props.choiceConvenienceTitle} data={props.choiceConvenienceData} />
                    <CustomCards title={props.title} data={props.data} />
                </Col>
                <Col md={6} lg={4} className='mx-auto'>
                    <ScheduleForm
                        productUrl={props.productUrl}
                        isBusinessSolutions={props.isBusinessSolutions}
                        formState={props.formState}
                        basicInfo={props.basicInfo}
                        journeyType={props.journeyType}
                        quoter={props.quoter}
                        onFieldChange={(field, value) => props.onFieldChange(field, value)}
                        setFormState={props.setFormState}
                        onNext={props.onNext}
                        onBack={goBack}
                        setMultiField={props.setMultiField}
                        sessionStorageHealthData={sessionStorageHealthData}
                    />
                </Col>
            </Row>
        </Container>
    );
}

SelectAppointment.propTypes = {
    isBusinessSolutions: PropTypes.bool,
    quoter: PropTypes.object,
    formState: PropTypes.object,
    basicInfo: PropTypes.object,
    onFieldChange: PropTypes.func,
    setMultiField: PropTypes.func,
    title: PropTypes.string,
    data: PropTypes.array,
    setFormState: PropTypes.func,
    choiceConvenienceTitle: PropTypes.string,
    choiceConvenienceData: PropTypes.array,
    onNext: PropTypes.func,
};

SelectAppointment.DefaultFormState = (prefill = false, basicInfo = null) => {
    return {
        firstName: prefill ? 'Example' : (basicInfo && basicInfo.firstName) || '',
        lastName: prefill ? 'Consumer' : (basicInfo && basicInfo.lastName) || '',
        email: prefill ? 'user@address.com' : (basicInfo && basicInfo.email) || '',
        specificAppt: 'asap',
        timeZone: (function () {
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const tz1 = TimeZones.find(e => e.zone === tz);
            return tz1 ? tz1.value : '';
        })(),
        specificApptDate: '',
        specificApptTime: '',
        phoneNumber: prefill ? '' : '',
        configurableQuestions: {},
    };
};
